import p from "./index81.mjs";
import { unescape as c } from "./index87.mjs";
function o(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function s(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? o(Object(t), !0).forEach(function(r) {
      p(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : o(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var a = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: c
};
function O() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  a = s(s({}, a), e);
}
export {
  O as setDefaults
};
